import {
    INVOICE_EXTENSIONS,
    INVOICE_MAX_SIZE_MB,
    INVOICE_MIME_TYPES,
    PREVIEW_KIND
} from "./constants";

const BYTES_IN_MB = 1024 * 1024;

/**
 * Guards the picker against unsupported files before any network call.
 * Returns an error message, or null when the file is accepted.
 * @param file
 */
export const validateInvoiceFile = (file) => {
    if (!file) return "No file selected.";

    const name = file.name?.toLowerCase() || "";
    const isSupported = INVOICE_MIME_TYPES.includes(file.type)
        || INVOICE_EXTENSIONS.some((ext) => name.endsWith(ext));

    if (!isSupported) return "Unsupported file type. Upload a PDF, JPG or PNG file.";
    if (file.size > INVOICE_MAX_SIZE_MB * BYTES_IN_MB) return `File is too large. The limit is ${INVOICE_MAX_SIZE_MB} MB.`;

    return null;
};

/**
 * Whether the confirmation step can draw the file itself. Images are shown
 * from a local object URL; PDFs fall back to a tile plus the stored copy's
 * link, which is enough to check the right file was picked.
 * @param file
 */
export const previewKindFor = (file) => {
    const name = file?.name?.toLowerCase() || "";
    const isPdf = file?.type === "application/pdf" || name.endsWith(".pdf");
    return isPdf ? PREVIEW_KIND.PDF : PREVIEW_KIND.IMAGE;
};
